module.exports = __webpack_public_path__ + "img/UP380C&BT1.d357b0bc.png";